import {Component, EventEmitter, Input, Output} from '@angular/core';
import {EditorModule} from "primeng/editor";
import {PrimeTemplate} from "primeng/api";
import {PrimeNgModule} from "../../prime-ng/prime-ng.module";

@Component({
  selector: 'app-editor-text',
  standalone: true,
    imports: [
        EditorModule,
        PrimeTemplate,
        PrimeNgModule
    ],
  templateUrl: './editor-text.component.html',
  styleUrl: './editor-text.component.scss'
})
export class EditorTextComponent {
    @Input()text: string = '';
    @Input()textReadOnly: boolean = false;
    @Output() onEventEmitterText = new EventEmitter<string>;

    emitTextChange() {
        this.onEventEmitterText.emit(this.text);
    }
}
